import React from "react";
import { parsedUserData } from '../../Admin/Utils';

const ProjectTransaction = () => {
  const handleNotLogin = (action) => {
    document.getElementById("overlay").style.display = "block";
    document.getElementById("login_title").textContent =
      action === "View Transactions" ? "View All Project Transactions" : "View All Project Transactions";
  };

  const transactions = [
    {
      date: "01 feb 2025",
      price: "rs 2.25 Cr",
      area: "1872 (carpet)",
      pricePerSqft: "rs 10932",
      floor: "12",
      tower: "-",
      purchaseType: "-"
    },
    {
      date: "01 feb 2025",
      price: "rs 2.25 Cr",
      area: "1872 (carpet)",
      pricePerSqft: "rs 10932",
      floor: "12",
      tower: "-",
      purchaseType: "-"
    },
    {
      date: "01 feb 2025",
      price: "rs 2.25 Cr",
      area: "1872 (carpet)",
      pricePerSqft: "rs 10932",
      floor: "12",
      tower: "-",
      purchaseType: "-"
    },
    {
      date: "02 feb 2025",
      price: "rs 2.30 Cr",
      area: "1900 (carpet)",
      pricePerSqft: "rs 12100",
      floor: "10",
      tower: "A",
      purchaseType: "Resale"
    }
  ];

  return (
    <>
      <div className="tablebg">
        <h2 className="sec-title">Transaction details</h2>
        <div className="table-responsive-wrapper">
          <table className="table">
            <thead className="headrow">
              <tr>
                <th scope="col">Registry Date</th>
                <th scope="col">agreement price</th>
                <th scope="col">area (sq.ft)</th>
                <th scope="col">price/sq.ft</th>
                <th scope="col">floor no</th>
                <th scope="col">tower / wing</th>
                <th scope="col">purchase type</th>
              </tr>
            </thead>
            <tbody>
              {(parsedUserData ? transactions : transactions.slice(0, 2)).map((item, index) => (
                <tr className="bodyrow" key={index}>
                  <td scope="row">{item.date}</td>
                  <td>{item.price}</td>
                  <td>{item.area}</td>
                  <td>{item.pricePerSqft}</td>
                  <td>{item.floor}</td>
                  <td>{item.tower}</td>
                  <td>{item.purchaseType}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {!parsedUserData && (
            <button onClick={() => handleNotLogin("View Transactions")} className="btn sc text-uppercase transacbtn">
                <span>Login to view more</span>
            </button>
        )}
      </div>
    </>
  );
};

export default ProjectTransaction;
